import FetchStatusRepository            from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import Error                            from "../../../domain/fundamentals/message/error/Error";
import ErrorMessage                     from "../../../domain/fundamentals/message/error/ErrorMessage";
import ErrorRepository                  from "../../../domain/fundamentals/message/error/ErrorRepository";
import Errors                           from "../../../domain/fundamentals/message/error/Errors";
import ErrorTarget                      from "../../../domain/fundamentals/message/error/ErrorTarget";
import NotifyRepository                 from "../../../domain/fundamentals/message/notify/NotifyRepository";
import ReservationSetting               from "../../../domain/reservation/ReservationSetting";
import { ReservationSettingRepository } from "../../../domain/reservation/ReservationSettingRepository";
import FetchStatusDataSource            from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import ErrorDataSource                  from "../../../infrastructure/datasource/error/ErrorDataSource";
import NotifyDataSource                 from "../../../infrastructure/datasource/notify/NotifyDataSource";
import ReservationSettingDataSource
                                        from "../../../infrastructure/datasource/reservation/ReservationSettingDataSource";
import GetReservationSetting            from "./GetReservationSetting";

class SaveReservationSetting {
  constructor(
    private readonly dispatch,
    private readonly reservationSettingRepository: ReservationSettingRepository = new ReservationSettingDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly getReservationSetting: GetReservationSetting = new GetReservationSetting(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
    private readonly errorRepository: ErrorRepository = new ErrorDataSource(dispatch),
  ) {
  }

  public async execute(reservationSetting: ReservationSetting) {
    this.fetchStatusRepository.start();
    try {
      await this.reservationSettingRepository.save(reservationSetting);
      this.notifyRepository.saveSuccess();
      await this.getReservationSetting.execute();
    } catch (e) {
      const list: Error[] = e.response.data.errors.map(error => new Error(new ErrorTarget(error.target), new ErrorMessage(error.message)));
      this.notifyRepository.saveFailure();
      this.errorRepository.set(new Errors(list));
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default SaveReservationSetting;